"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateWithAccess = exports.state = exports.modelState = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
exports.modelState = {
    selectedTab: 0,
    isDefaultState: false,
    selectedPart: {
        name: 'Frontal Bone',
        identifier: 'cf3e6880d571779fd4ed792c006d473a',
    },
    isLoading: false,
    selectedModelIndex: 0,
    modelsAliases: {},
    models: [
        {
            index: 0,
            type: 0,
            identifier: 'fb035ecad39a3fa9087d10c86840e31f',
            image: 'modelsThumbnails/male/fullBody',
            isDetailed: false,
            mask: 0,
            name: 'Full Body',
            compactName: 'Full Body',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 1,
            type: 0,
            identifier: 'fb035ecad39a3fa9087d10c86840e31f',
            image: 'modelsThumbnails/male/head&neck',
            isDetailed: false,
            mask: 3,
            name: 'Head & Neck',
            compactName: 'Head & Neck',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 2,
            type: 0,
            identifier: 'fb035ecad39a3fa9087d10c86840e31f',
            image: 'modelsThumbnails/male/upperLimbRight',
            isDetailed: false,
            mask: 4,
            name: 'Upper Limb (Right)',
            compactName: 'Upper Limb (Right)',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 3,
            type: 0,
            identifier: 'fb035ecad39a3fa9087d10c86840e31f',
            image: 'modelsThumbnails/male/upperLimbLeft',
            isDetailed: false,
            mask: 8,
            name: 'Upper Limb (Left)',
            compactName: 'Upper Limb (Left)',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 4,
            type: 0,
            identifier: 'fb035ecad39a3fa9087d10c86840e31f',
            image: 'modelsThumbnails/male/thorax',
            isDetailed: false,
            mask: 16,
            name: 'Thorax',
            compactName: 'Thorax',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 5,
            type: 0,
            identifier: 'fb035ecad39a3fa9087d10c86840e31f',
            image: 'modelsThumbnails/male/abdomen',
            isDetailed: false,
            mask: 32,
            name: 'Abdomen',
            compactName: 'Abdomen',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 6,
            type: 0,
            identifier: 'fb035ecad39a3fa9087d10c86840e31f',
            image: 'modelsThumbnails/male/pelvis&perineum',
            isDetailed: false,
            mask: 128,
            name: 'Pelvis & Perineum',
            compactName: 'Pelvis & Perineum',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 7,
            type: 0,
            identifier: 'fb035ecad39a3fa9087d10c86840e31f',
            image: 'modelsThumbnails/male/back',
            isDetailed: false,
            mask: 64,
            name: 'Back',
            compactName: 'Back',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 8,
            type: 0,
            identifier: 'fb035ecad39a3fa9087d10c86840e31f',
            image: 'modelsThumbnails/male/lowerLimbRight',
            isDetailed: false,
            mask: 256,
            name: 'Lower Limb (Right)',
            compactName: 'Lower Limb (Right)',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 9,
            type: 0,
            identifier: 'fb035ecad39a3fa9087d10c86840e31f',
            image: 'modelsThumbnails/male/lowerLimbLeft',
            isDetailed: false,
            mask: 512,
            name: 'Lower Limb (Left)',
            compactName: 'Lower Limb (Left)',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 10,
            type: 1,
            identifier: '964db2dd4f98052f03baa9ca5f2dbcae',
            image: 'modelsThumbnails/female/fullBody',
            isDetailed: false,
            mask: 0,
            name: 'Full Body',
            compactName: 'Full Body',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 11,
            type: 1,
            identifier: '964db2dd4f98052f03baa9ca5f2dbcae',
            image: 'modelsThumbnails/female/head&neck',
            isDetailed: false,
            mask: 3,
            name: 'Head & Neck',
            compactName: 'Head & Neck',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 12,
            type: 1,
            identifier: '964db2dd4f98052f03baa9ca5f2dbcae',
            image: 'modelsThumbnails/female/upperLimbRight',
            isDetailed: false,
            mask: 4,
            name: 'Upper Limb (Right)',
            compactName: 'Upper Limb (Right)',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 13,
            type: 1,
            identifier: '964db2dd4f98052f03baa9ca5f2dbcae',
            image: 'modelsThumbnails/female/upperLimbLeft',
            isDetailed: false,
            mask: 8,
            name: 'Upper Limb (Left)',
            compactName: 'Upper Limb (Left)',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 14,
            type: 1,
            identifier: '964db2dd4f98052f03baa9ca5f2dbcae',
            image: 'modelsThumbnails/female/thorax',
            isDetailed: false,
            mask: 16,
            name: 'Thorax',
            compactName: 'Thorax',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 15,
            type: 1,
            identifier: '964db2dd4f98052f03baa9ca5f2dbcae',
            image: 'modelsThumbnails/female/abdomen',
            isDetailed: false,
            mask: 32,
            name: 'Abdomen',
            compactName: 'Abdomen',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 16,
            type: 1,
            identifier: '964db2dd4f98052f03baa9ca5f2dbcae',
            image: 'modelsThumbnails/female/pelvis&perineum',
            isDetailed: false,
            mask: 128,
            name: 'Pelvis & Perineum',
            compactName: 'Pelvis & Perineum',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 17,
            type: 1,
            identifier: '964db2dd4f98052f03baa9ca5f2dbcae',
            image: 'modelsThumbnails/female/back',
            isDetailed: false,
            mask: 64,
            name: 'Back',
            compactName: 'Back',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 18,
            type: 1,
            identifier: '964db2dd4f98052f03baa9ca5f2dbcae',
            image: 'modelsThumbnails/female/lowerLimbRight',
            isDetailed: false,
            mask: 256,
            name: 'Lower Limb (Right)',
            compactName: 'Lower Limb (Right)',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 19,
            type: 1,
            identifier: '964db2dd4f98052f03baa9ca5f2dbcae',
            image: 'modelsThumbnails/female/lowerLimbLeft',
            isDetailed: false,
            mask: 512,
            name: 'Lower Limb (Left)',
            compactName: 'Lower Limb (Left)',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 32,
            type: 16,
            identifier: '52d1ef68e17c6952b882ca7b04454683',
            image: 'modelsThumbnails/eye',
            isDetailed: true,
            mask: 0,
            name: 'Eye',
            compactName: 'Eye',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 33,
            type: 4,
            identifier: '67ae6110b258ecc139e7e6f3661cb06e',
            image: 'modelsThumbnails/lymphNode',
            isDetailed: true,
            mask: 0,
            name: 'Lymph Node',
            compactName: 'Lymph Node',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 34,
            type: 19,
            identifier: 'e6603395a570d06a42e62c96828545e4',
            image: 'modelsThumbnails/tongue',
            isDetailed: true,
            mask: 0,
            name: 'Tongue',
            compactName: 'Tongue',
            access: 0,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 35,
            type: 5,
            identifier: 'ba34cc84df25e5d96d57ebe6b7cf13af',
            image: 'modelsThumbnails/peripheralNerve',
            isDetailed: true,
            mask: 0,
            name: 'Peripheral Nerve',
            compactName: 'Peripheral Nerve',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 36,
            type: 3,
            identifier: '7d3a1e8c702aaa054cddd07171986fd8',
            image: 'modelsThumbnails/bronchialTree',
            isDetailed: true,
            mask: 0,
            name: 'Bronchial Tree',
            compactName: 'Bronchial Tree',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 37,
            type: 20,
            identifier: '95f6a9ba10761520265429c9b78a9b84',
            image: 'modelsThumbnails/adrenalGland',
            isDetailed: true,
            mask: 0,
            name: 'Suprarenal Gland',
            compactName: 'Suprarenal Gland',
            isNew: true,
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 38,
            type: 6,
            identifier: '6ca0d6d7577c9ac5a3a5a758eb600d2d',
            image: 'modelsThumbnails/skeletalMuscle',
            isDetailed: true,
            mask: 0,
            name: 'Skeletal Muscle',
            compactName: 'Skeletal Muscle',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 39,
            type: 22,
            identifier: 'cb0ea7054b88ce61157b0c0bf5da20e3',
            image: 'modelsThumbnails/olfactoryBulb',
            isDetailed: true,
            mask: 0,
            name: 'Olfactory Organ',
            compactName: 'Olfactory Organ',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 40,
            type: 17,
            identifier: '752e04e384ce0e5bb0da5886909c6589',
            image: 'modelsThumbnails/tendon',
            isDetailed: true,
            mask: 0,
            name: 'Tendon',
            compactName: 'Tendon',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 41,
            type: 6,
            identifier: '12d1806d32dafd3bdf83c3cd58d7a431',
            image: 'modelsThumbnails/skeletalMuscleFiber',
            isDetailed: true,
            mask: 0,
            name: 'Skeletal Muscle Fiber',
            compactName: 'Skeletal Muscle Fiber',
            isNew: true,
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 42,
            type: 8,
            identifier: 'f7cbb835f718a4b11e5c21a8f88fc402',
            image: 'modelsThumbnails/boneCrossSection',
            isDetailed: true,
            mask: 0,
            name: 'Bone Cross Section',
            compactName: 'Bone Cross Section',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 43,
            type: 9,
            identifier: '308de411dccf3912c46cc06a03776485',
            image: 'modelsThumbnails/skin',
            isDetailed: true,
            mask: 0,
            name: 'Skin',
            compactName: 'Skin',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 44,
            type: 18,
            identifier: '3b978a0adcecd9c90d34cc3b166595db',
            image: 'modelsThumbnails/tooth',
            isDetailed: true,
            mask: 0,
            name: 'Tooth',
            compactName: 'Tooth',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 45,
            type: 23,
            identifier: 'af9103e988e16093162c9cfed119e44a',
            image: 'modelsThumbnails/cochlea',
            isDetailed: true,
            mask: 0,
            name: 'Cochlea',
            compactName: 'Cochlea',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 46,
            type: 21,
            identifier: '67c586c91cfdd00acdec10281bcaa5d9',
            image: 'modelsThumbnails/renalPyramid',
            isDetailed: true,
            mask: 0,
            name: 'Kidney Lobe',
            compactName: 'Kidney Lobe',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 47,
            type: 2,
            identifier: '0bd179b760d87fa5b6d26df79c4cbf1f',
            image: 'modelsThumbnails/bloodVessels',
            isDetailed: true,
            mask: 0,
            name: 'Blood Vessels',
            compactName: 'Blood Vessels',
            access: 1,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 48,
            type: 28,
            identifier: 'photoreceptors',
            image: 'modelsThumbnails/photoreceptorCells',
            isDetailed: true,
            mask: 0,
            name: 'Photoreceptor Cells',
            compactName: 'Photoreceptor Cells',
            access: 0,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 49,
            type: 25,
            identifier: 'oocyte',
            image: 'modelsThumbnails/secondaryOocyte',
            isDetailed: true,
            mask: 0,
            name: 'Secondary Oocyte',
            compactName: 'Secondary Oocyte',
            access: 0,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 50,
            type: 26,
            identifier: 'sperm',
            image: 'modelsThumbnails/sperm',
            isDetailed: true,
            mask: 0,
            name: 'Sperm',
            compactName: 'Sperm',
            access: 0,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 24,
            type: 34,
            identifier: 'cad5151700f64942ab93c90d8c0b79cc',
            image: 'modelsThumbnails/clitorisAndPenis',
            isDetailed: true,
            mask: 0,
            name: 'Clitoris and Penis',
            compactName: 'Clitoris and Penis',
            isNew: true,
            access: 0,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
        {
            index: 39,
            type: 35,
            identifier: '52d12b9268877e502b014d953e8c4de1',
            image: 'modelsThumbnails/ovarianCycle',
            isDetailed: true,
            mask: 0,
            name: 'Ovarian Cycle',
            compactName: 'Ovarian Cycle',
            isNew: true,
            access: 0,
            isPinned: false,
            isAvailable: true,
            isOnDemand: false,
        },
    ],
    undoRedoState: {
        isClearAllActive: false,
        isRedoActive: false,
        isUndoActive: false,
        isUndoAllActive: false,
        redoItems: [],
        undoItems: [],
    },
};
exports.state = {
    modelState: exports.modelState,
    deviceInformation: {
        kind: bridge_schema_1.DeviceKind.Phone,
        platform: bridge_schema_1.Platform.iPhone,
    },
};
exports.stateWithAccess = Object.assign(Object.assign({}, exports.state), { userLicenses: [{ isActive: true }], currentUser: { email: 'test@.t.t' } });
